import { surveillanceService } from '../../services'

const initialState = {
    surveillance: { loading: true, error: null, data: null },
    surveillances: { loading: true, data: null, error: null },
    selectedVariables: { loading: false, data: null, surv: null, keys: null, view: null, error: null },
    expandedElements: { loading: true, data: null, keys: null, error: null },
    dateRange: { start: new Date(new Date().getFullYear() - 1, 0, 1).getTime(), end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59, 999).getTime(), data: null, error: null },
    ytdOffsets: { min: 0, max: 0 },
    maxMeasureCount: { data: 50000, error: null },
    selectedUtam: { data: null, set: false, error: null },
    yAxis: [
        {
            index: 0,
            unite: 'Pas de données',
            titre: '',
            min: undefined,
            max: undefined,
            decalage: undefined,
        }
    ],
    history: [{
        start: new Date(new Date().getFullYear() - 1, 0, 1)
            .toLocaleDateString('fr-CA'),
        end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59, 999)
            .toLocaleDateString('fr-CA'),
        activeDate: "YTD-1"
    }],
    historyIndex: 0,
    legendMode: 'short'    
}

export const surveillance = {
    namespaced: true,
    state: initialState,
    getters: {
        surveillances: (state) => {
            return state.surveillances
        },
        surveillance: (state) => {
            return state.surveillance
        },
        surveillanceArborescence: (state) => {
            if (state.surveillance.data && state.surveillance.data.arborescence) {
                return state.surveillance.data.arborescence
            } else {
                return null
            }
        },
        surveillanceSelectedVariables: (state) => {
            return state.selectedVariables
        },
        surveillanceSelectedKeys: (state) => {
            if (state.selectedVariables && state.selectedVariables.keys) {
                return state.selectedVariables.keys
            } else {
                return {}
            }
        },
        surveillanceExpandedKeys: (state) => {
            if (state.expandedElements && state.expandedElements.keys) {
                return state.expandedElements.keys
            } else {
                return {}
            }
        },
        surveillanceSelectedView: (state) => {
            if (state.selectedVariables && state.selectedVariables.view) {
                return state.selectedVariables.view
            } else {
                return null
            }
        },
        surveillanceSelectedSurv: (state) => {
            if (state.selectedVariables && state.selectedVariables.surv) {
                return state.selectedVariables.surv
            } else {
                return null
            }
        },
        dateRange: (state) => {
            if (state.dateRange && state.dateRange.start && state.dateRange.end) {
                return state.dateRange
            } else {
                return null
            }
        },
        ytdOffsets: (state) => {
            if (state.ytdOffsets !== undefined && state.ytdOffsets.min !== undefined && state.ytdOffsets.max !== undefined) {
                return state.ytdOffsets
            } else {
                return null
            }
        },
        graphMaxMeasureCount: (state) => {
            if (state.maxMeasureCount && state.maxMeasureCount.data) {
                return state.maxMeasureCount.data
            } else {
                return null
            }
        },
        selectedUtam: (state) => {
            if (state.selectedUtam && state.selectedUtam.data) {
                return state.selectedUtam.data
            } else {
                return null
            }
        },
        yAxis: (state) => {
            return state.yAxis
        },
        history: (state) => {
            return state.history
        },
        historyIndex: (state) => {
            return state.historyIndex
        },
        legendMode: (state) => {
            return state.legendMode
        },
    },
    actions: {
        clearCurrentSurveillance({ commit }) {
            commit('clearSurveillance')
        },
        getAll({ commit }) {
            commit('getMultipleRequest')

            surveillanceService.getAll()
                .then(
                    data => {
                        commit('getMultipleSuccess', data)
                    },
                    error => {
                        commit('getMultipleFailure', error)
                    }
                )
        },
        getById({ commit }, { survId }) {
            commit('getRequest')

            return surveillanceService.getById(survId)
                .then(
                    data => {
                        surveillanceService.getArborescenceActive(survId)
                            .then(
                                arboData => {
                                    data.arborescence = arboData
                                    commit('getSuccess', data)
                                },
                                error => {
                                    data.arborescence = null
                                    commit('getFailure', error)
                                }
                            )
                    },
                    error => {
                        commit('getFailure', error)
                    }
                )
        },
        getForUtam({ commit }, { utamId }) {
            commit('getMultipleRequest')

            return surveillanceService.getAllByUtam(utamId)
                .then(
                    data => {
                        commit('getMultipleSuccess', data)
                    },
                    error => {
                        commit('getMultipleFailure', error)
                    }
                )
        },
        getVariableData({ commit }, { variableGuid, variableDetail, selectedSurv }) {
            commit('getVariablesRequest')

            return surveillanceService.getVariableData(variableGuid)
                .then(
                    data => {
                        var completeData = []
                        variableDetail['data'] = data.data
                        variableDetail.survId = selectedSurv
                        completeData[variableDetail.guidVariable] = variableDetail
                        commit('getVariablesSuccess', completeData)
                    },
                    error => {
                        commit('getVariablesError', error)
                    }
                )
        },
        getVariablesData({ commit }, { variablesGuids, variablesDetails, selectedSurv }) {
            commit('getVariablesRequest')

            return surveillanceService.getVariablesData(variablesGuids)
                .then(
                    data => {
                        var completeData = []
                        data.forEach(currData => {
                            var variableDetail = variablesDetails[currData.variableGuid]
                            variableDetail['data'] = currData.data
                            variableDetail.survId = selectedSurv
                            completeData[variableDetail.guidVariable] = variableDetail
                        })
                        commit('getVariablesSuccess', completeData)
                    },
                    error => {
                        commit('getVariablesError', error)
                    }
                )
        },
        getVariablesGrapheur({ commit }, { variablesGuids, dateDebut, dateFin, maxMeasureCount, variablesDetails, selectedSurv }) {
            commit('getVariablesRequest');
            return surveillanceService.getVariablesGrapheur(variablesGuids, dateDebut, dateFin, maxMeasureCount)
                .then(
                    data => {
                        let completeData = [];
                        let minDate = null, maxDate = null;

                        data.forEach(currData => {
                            let variableDetail

                            if (currData.idVariableCalculee) { // Dans le cas d'une variable calculée, guid = guid_variable + "_" + id_variable_calculee
                                variableDetail = variablesDetails[currData.variableGuid + "_" + currData.idVariableCalculee];
                            }
                            else {
                                variableDetail = variablesDetails[currData.variableGuid];
                            }

                            variableDetail.libVariable = currData.name
                            variableDetail['metadata'] = currData.variableMetadata;
                            variableDetail['data'] = currData.data;
                            variableDetail['dataType'] = currData.dataType;
                            variableDetail.survId = selectedSurv;
                            completeData[variableDetail.guidVariable] = variableDetail;

                            // Définition des min/max dates globales
                            if (
                                currData.variableMetadata.globalMinDate != null &&
                                (!minDate || new Date(currData.variableMetadata.globalMinDate) < new Date(minDate))
                            ) {
                                minDate = currData.variableMetadata.globalMinDate;
                            }

                            if (
                                currData.variableMetadata.globalMaxDate != null &&
                                (!maxDate || new Date(currData.variableMetadata.globalMaxDate) > new Date(maxDate))
                            ) {
                                maxDate = currData.variableMetadata.globalMaxDate;
                            }
                        });
                        commit('getVariablesSuccess', completeData);
                        commit('updateOffsets');
                        
                        // Si dateDebut et dateFin sont null, on prend les valeurs trouvées
                        const isHistorical = !dateFin;
                        if (!dateDebut){
                            dateDebut = minDate ?? "1950-01-01T00:00:00";
                        } 
                        if (!dateFin){
                            dateFin = maxDate ?? new Date().toISOString();
                        }  
                        function getNextDayMidnightLocal(dateStr) {
                            const date = new Date(dateStr);

                            //date.setDate(date.getDate() + 1);

                            date.setHours(23, 59, 0, 0);

                            return date.getTime();
                        }
                        
                        commit('setDateRange', {
                            rangeStart: new Date(dateDebut).getTime(),
                            rangeEnd: isHistorical ? getNextDayMidnightLocal(dateFin) : new Date(dateFin).getTime()
                        });
                        
                    },
                    error => {
                        commit('getVariablesError', error);
                        throw error;
                    }
                )

        },

        setGraphDateRange({ commit }, { start, end }) {
            commit('setDateRange', { rangeStart: start, rangeEnd: end })
        },
        setGraphMaxMeasureCount({ commit }, { qty }) {
            commit('setMaxMeasureCount', { value: qty })
        },
        calculateOffsets({ commit }) {
            commit('updateOffsets')
        },
        setVariablesData({ commit }, { variablesData }) {
            commit('setSelectedVariable', variablesData)
        },
        updateVariableData({ commit }, { variableData }) {
            commit('updateSelectedVariable', variableData)
        },
        addSelectedVariable({ commit }, { variable }) {
            commit('addSelectedVariable', variable)
        },
        deleteVariableData({ commit }, { variableGuid, deleteError }) {
            commit('deleteSelectedVariable', variableGuid, deleteError)
        },
        deleteVariablesData({ commit }, { variablesGuids }) {
            variablesGuids.forEach(variableGuid => {
                commit('deleteSelectedVariable', variableGuid)
            })
        },
        swapVariables({ commit }, { variableGuid1, variableGuid2 }) {
            var guids = { variableGuid1, variableGuid2 }
            commit('swapVariables', guids)
        },
        setSelectedSurv({ commit }, { survId }) {
            commit('updateSelectedSurv', survId)
        },
        setSelectedKeys({ commit }, { selectedKeys }) {
            commit('updateSelectedKeys', selectedKeys)
        },
        addSelectedKey({ commit }, { selectedKeysToAdd }) {
            commit('addSelectedKey', selectedKeysToAdd)
        },
        deleteSelectedKey({ commit }, { selectedKeysToDelete }) {
            commit('deleteSelectedKey', selectedKeysToDelete)
        },
        resetSelectedKeys({ commit }) {
            commit('clearSelectedKeys')
        },
        setExpandedKeys({ commit }, { expandedKeys }) {
            commit('updateExpandedKeys', expandedKeys)
        },
        deleteExpandedKey({ commit }, { expandedKeysToDelete }) {
            commit('deleteExpandedKey', expandedKeysToDelete)
        },
        resetExpandedKeys({ commit }) {
            commit('clearExpandedKeys')
        },
        updateSelectedView({ commit }, { viewId }) {
            commit('getVariablesRequest')
            return surveillanceService.getView(viewId)
                .then(
                    data => {
                        commit('getViewSuccess', data)
                    },
                    error => {
                        commit('getViewError', error)
                    }
                )
        },
        setSelectedViewState({ commit }, { data }) {
            commit('updateSelectedViewState', data)
        },
        resetSelectedView({ commit }) {
            commit('clearSelectedView')
        },
        setSelectedUtam({ commit }, { utam }) {
            commit('setUtam', utam)
        },
        resetSelectedUtam({ commit }) {
            commit('resetUtam')
        },
        setYAxis({ commit }, yAxis) {
            commit('setYAxis', yAxis)
        },
        setHistory({ commit }, payload) {
            commit('setHistory', payload)
        },
        setHistoryIndex({ commit }, { index }) {
            commit('setHistoryIndex', index)
        },
        setLegendMode({ commit }, mode) {
            commit('setLegendMode', mode)
        }
    },
    mutations: {
        setLegendMode(state, mode) {
            state.legendMode = mode
        },
        getMultipleRequest(state) {
            state.surveillances.loading = true
            state.surveillances.error = null
        },
        getRequest(state) {
            state.surveillance.loading = true
            state.surveillance.error = null
        },
        getMultipleSuccess(state, data) {
            state.surveillances.loading = false
            state.surveillances.data = data
            state.surveillances.error = null
        },
        getSuccess(state, data) {
            state.surveillance.loading = false
            state.surveillance.data = data
            state.surveillance.error = null
        },
        getMultipleFailure(state, error) {
            state.surveillances.loading = false
            state.surveillances.data = null
            state.surveillances.error = error
        },
        getFailure(state, error) {
            state.surveillance.loading = false
            state.surveillance.data = null
            state.surveillance.error = error
        },
        clearSurveillance(state) {
            state.surveillance.loading = false
            state.surveillance.data = null
            state.surveillance.error = null
            state.selectedVariables.surv = null
        },
        getVariablesRequest(state) {
            state.selectedVariables.loading = true
            state.selectedVariables.error = null
        },
        updateSelectedVariable(state, variableData) {
            state.selectedVariables.loading = true
            var variablesData = {}
            if (state.selectedVariables.data !== null) {
                variablesData = Object.assign({}, state.selectedVariables.data)
            }
            for (var dataKeys in variableData.variableData) {
                if (dataKeys === "typeChart" && variableData.variableData[dataKeys] === 'line') {
                    variableData.variableData[dataKeys] = variablesData.dataType === 'System.Boolean' ? 'column' : 'line';
                }
                variablesData[variableData.guid][dataKeys] = variableData.variableData[dataKeys]
            }

            state.selectedVariables.data = variablesData
            state.selectedVariables.loading = false
            state.selectedVariables.error = null
        },
        setSelectedVariable(state, variablesData) {
            state.selectedVariables.data = variablesData
            state.selectedVariables.loading = false
            state.selectedVariables.error = null
        },
        setDateRange(state, range) {
            state.dateRange.start = range.rangeStart
            state.dateRange.end = range.rangeEnd
        },
        updateOffsets(state) {
            let ytdOffsetMin = 0
            // let ytdOffsetMax = 0

            // Dans les cas où on remet à jour la plage de dates du grapheur avec 'YTD' comme plage de dates, par défaut la date min est réajustée au niveau de la date
            //      de la première valeur de l'année de la dernière valeur
            // Si on veut que YTD soit fixe et non dépendant de la plage de dates des données récupérées, il faut appliquer un offsetMin égal au différentiel entre la date
            //      en question et le premier janvier de l'année correspondante, qui sera AJOUTE au 'start' de la plage de dates servant à alimenter les paramètres
            //      de la requête API récupérant le dataset à afficher

            if ((state.selectedVariables.keys !== null) && (Object.keys(state.selectedVariables.keys).length > 0) && (Object.keys(state.selectedVariables.data).length > 0)) {
                let lowerBound = new Date().getTime()
                let upperBound = 0
                let ubIndex = 0

                Object.keys(state.selectedVariables.data).forEach(index => {
                    let dataset = state.selectedVariables.data[index].data

                    if (dataset.length > 0) {
                        if (new Date(dataset[dataset.length - 1].date).getTime() > upperBound) {
                            upperBound = new Date(dataset[dataset.length - 1].date).getTime()
                            ubIndex = index
                        }
                        if (new Date(dataset[0].date).getTime() > lowerBound) {
                            lowerBound = new Date(dataset[0].date).getTime()
                        }
                    }
                })
                var mdcDate = (upperBound === 0) ? new Date() : new Date(upperBound) // à changer ?
                var ytdJanFirst = new Date(mdcDate.getFullYear(), 0, 1, 0, 0, 0) // on applique l'offset "-1 an" directement dans le param offsetMin du bouton YTD-1

                var offsetTargetDates = []
                let ubDataset = (ubIndex !== 0) ? state.selectedVariables.data[ubIndex].data : []
                for (var i = 0; i < ubDataset.length; i++) {
                    let variable = ubDataset[i]
                    let cd = new Date(variable.date)
                    if (cd.getFullYear() === mdcDate.getFullYear()) {
                        offsetTargetDates.push(cd)
                    }
                }
                var offsetTargetDate = offsetTargetDates[0] // la première valeur du dataset rencontrée dont l'année est l'année de la dernière valeur

                ytdOffsetMin = ytdJanFirst.getTime() - (new Date(offsetTargetDate)).getTime()
            } // pas de else : sans dataset, on laisse les offsets à 0

            state.ytdOffsets.min = ytdOffsetMin
            // state.ytdOffsets.max = ytdOffsetMax
        },
        setMaxMeasureCount(state, qty) {
            state.maxMeasureCount.data = qty.value
        },
        addSelectedVariable(state, variable) {
            state.selectedVariables.loading = true;

            if (state.selectedVariables.data === null) {
                state.selectedVariables.data = {};
            }

            // Ajout de la variable (clé = guidVariable)
            state.selectedVariables.data[variable.guidVariable] = variable;


            state.selectedVariables.loading = false;
            state.selectedVariables.error = null;
        },

        deleteSelectedVariable(state, variableGuid, deleteError = true) {
            state.selectedVariables.loading = true
            if (state.selectedVariables.data !== null) {
                delete state.selectedVariables.data[variableGuid]
            }

            // A retirer potentiellement
            if ((state.selectedVariables.data !== null) && (Object.keys(state.selectedVariables.data).length === 0)) { // Réinitialise la plage de dates si la dernière variable est désélectionnée
                state.dateRange.start = new Date(new Date().getFullYear() - 1, 0, 1, 1).getTime()
                state.dateRange.end = (new Date().getTime() - new Date().getTimezoneOffset() * 60000)
            }

            state.selectedVariables.loading = false
            if (!deleteError) state.selectedVariables.error = null
        },
        getVariablesSuccess(state, data) {
            var variablesData = {}
            state.selectedVariables.error = null

            if (state.selectedVariables.data !== null) {
                variablesData = Object.assign({}, state.selectedVariables.data)
            }
            Object.values(data).forEach(variableData => {
                variablesData[variableData.guidVariable] = variableData
            })

            state.selectedVariables.loading = false
            state.selectedVariables.data = variablesData
        },
        getVariablesError(state, error) {
            state.selectedVariables.loading = false
            //state.selectedVariables.data = {}
            state.selectedVariables.error = error.response?.data?.message || error.message
        },
        swapVariables(state, guids) {
            //On descend guid1 et on monte guid2
            var newOrderVariablesData = {}
            var copyData = { ...state.selectedVariables.data }
            var alreadySwap = false

            Object.values(copyData).forEach(v => {
                if (v.guidVariable != guids.variableGuid1 && v.guidVariable != guids.variableGuid2) {
                    newOrderVariablesData[v.guidVariable] = v
                }
                else if (!alreadySwap) {
                    newOrderVariablesData[guids.variableGuid2] = Object.values(copyData).find(va => va.guidVariable == guids.variableGuid2)
                    newOrderVariablesData[guids.variableGuid1] = Object.values(copyData).find(va => va.guidVariable == guids.variableGuid1)
                    alreadySwap = true
                }
            })

            state.selectedVariables.data = newOrderVariablesData
        },
        updateSelectedSurv(state, survId) {
            state.selectedVariables.surv = survId
        },
        updateSelectedKeys(state, selectedKeys) {
            state.selectedVariables.keys = selectedKeys
        },
        addSelectedKey(state, selectedKeysToAdd) {

            if (state.selectedVariables.keys === null) {
                state.selectedVariables.keys = {};
            }

            const selectedKeys = Object.assign({}, state.selectedVariables.keys);

            selectedKeysToAdd.forEach(keyObj => {
                // Exemple : { key: "my_key_1234", value: true }
                if (keyObj.key && keyObj.value !== undefined) {
                    selectedKeys[keyObj.key] = keyObj.value;
                }
            });

            state.selectedVariables.keys = selectedKeys;
        },
        deleteSelectedKey(state, selectedKeysToDelete) {
            var selectedKeys = {}
            if (state.selectedVariables.keys !== null) {
                selectedKeys = Object.assign({}, state.selectedVariables.keys)
            }
            var keysToDelete = []
            Object.keys(selectedKeys).forEach(key => {
                selectedKeysToDelete.forEach(selectedKey => {
                    if (key.endsWith('_' + selectedKey)) {
                        keysToDelete.push(key)
                    }
                })
            })
            keysToDelete.forEach(key => {
                delete selectedKeys[key]
            })
            state.selectedVariables.keys = selectedKeys
        },
        clearSelectedKeys(state) {
            state.selectedVariables.keys = null
        },
        updateExpandedKeys(state, expandedKeys) {
            state.expandedElements.keys = expandedKeys
        },
        deleteExpandedKey(state, expandedKeysToDelete) {
            var expandedKeys = {}
            if (state.expandedElements.keys !== null) {
                expandedKeys = Object.assign({}, state.expandedElements.keys)
            }
            var keysToDelete = []
            Object.keys(expandedKeys).forEach(key => {
                expandedKeysToDelete.forEach(expandedKey => {
                    if (key.includes('_' + expandedKey)) {
                        keysToDelete.push(key)
                    }
                })
            })
            keysToDelete.forEach(key => {
                delete expandedKeys[key]
            })
            state.expandedElements.keys = expandedKeys
        },
        clearExpandedKeys(state) {
            state.expandedElements.keys = null
        },
        updateSelectedViewState(state, data) {
            var selectedView = Object.assign({}, state.selectedVariables.view)
            selectedView.state = data
            state.selectedVariables.view = selectedView
        },
        getViewSuccess(state, data) {
            state.selectedVariables.loading = false
            data.state = {
                rendered: false
            }
            state.selectedVariables.view = data
            state.selectedVariables.error = null
        },
        getViewError(state, error) {
            state.selectedVariables.loading = false
            state.selectedVariables.view = null
            state.selectedVariables.error = error
        },
        clearSelectedView(state) {
            state.selectedVariables.view = null
        },
        setUtam(state, data) {
            state.selectedUtam.data = data
            state.selectedUtam.error = false
            state.selectedUtam.set = true
        },
        resetUtam(state) {
            state.selectedUtam.data = null
            state.selectedUtam.set = false
        },
        setYAxis(state, yAxis) {
            state.yAxis = yAxis;

        },
        setHistory(state, data) {
            state.historyIndex = data.historyIndex;
            state.history = data.history;
        },
        setHistoryIndex(state, data) {
            state.historyIndex = data;

        }
    }
}
